var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7656 0.234391C11.4531 -0.0781305 10.9468 -0.0781305 10.6343 0.234391L5.99968 4.86902L1.36505 0.234391C1.05252 -0.0775971 0.546779 -0.0770771 0.234257 0.234912C-0.0777319 0.547434 -0.0782652 1.05318 0.233736 1.3657L4.86837 6.00033L0.233736 10.635C-0.0782528 10.9475 -0.0777328 11.4532 0.234257 11.7657C0.546779 12.0777 1.05252 12.0783 1.36505 11.7663L5.99968 7.13164L10.6343 11.7663C10.9468 12.0783 11.4526 12.0777 11.7651 11.7657C12.0771 11.4532 12.0776 10.9475 11.7656 10.635L7.13099 6.00033L11.7656 1.3657C11.9156 1.21569 12 1.01204 12 0.800047C12 0.58805 11.9156 0.3844 11.7656 0.234392L11.7656 0.234391Z",
    fill: "#E74C3C",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCross);
export default __webpack_public_path__ + "static/media/closeCross.7f03ee57b7f90832af590d7ed751e9e3.svg";
export { ForwardRef as ReactComponent };